import { z } from 'zod';

/** @deprecated */
export interface MapLocation {
    latitude: number;
    longitude: number;
}

/** @deprecated */
export const mapLocationSchema = z.object({
    latitude: z.number(),
    longitude: z.number(),
});
